module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', {
    staticStyle: {
      "min-width": "320px"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Billing Name as per Xero")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-autocomplete', {
    attrs: {
      "prepend-icon": "groups",
      "items": _vm.clientGroups,
      "label": "Select Group",
      "hide-details": "",
      "item-text": "Name",
      "chips": "",
      "return-object": ""
    },
    model: {
      value: (_vm.selectedGroup),
      callback: function($$v) {
        _vm.selectedGroup = $$v
      },
      expression: "selectedGroup"
    }
  }), _vm._v(" "), _c('v-row', {
    staticClass: "pt-2"
  }, [_c('v-col', [_c('v-list-item', {
    staticClass: "pa-0"
  }, [_c('v-list-item-content', _vm._l((_vm.selectedClients), function(client, index) {
    return _c('v-list-item-subtitle', {
      key: index
    }, [_c('v-icon', {
      attrs: {
        "color": "green",
        "small": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v(" " + _vm._s(client.name))], 1)
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    attrs: {
      "disabled": !_vm.selectedGroup
    },
    on: {
      "click": _vm.saveClientGroup
    }
  }, [_vm._v("Save changes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "hide-overlay": "",
      "persistent": "",
      "width": "250"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('v-card', {
    attrs: {
      "color": "primary",
      "dark": ""
    }
  }, [_c('v-card-text', [_vm._v("\n        Please stand by\n        "), _c('v-progress-linear', {
    staticClass: "mb-0",
    attrs: {
      "indeterminate": "",
      "color": "white"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8770bfec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Client/ClientGroupModal.vue
// module id = 2230
// module chunks = 0